import { CSSProperties } from "react";

/**
 * The shared Tooltip wraps its children in a real <button> and gives it no
 * styling of its own, so the browser's default button chrome (a grey fill, a
 * border and padding) shows up around whatever you hang a tooltip on. Every
 * tooltip that decorates plain content therefore has to strip that chrome.
 *
 * Kept in one place because it was copied inline five times in this scene and
 * every new tooltip needed the same three lines. Forgetting them is what made
 * the "(?)" next to the automatic waiting list look like a white block
 * (DEV-3063).
 */
export const BARE_TOOLTIP_TRIGGER_STYLE: CSSProperties = {
  background: "transparent",
  border: "none",
  padding: 0,
};
